import {GetterTree} from 'vuex';
import {RootState} from '@/store';
import {CategoryState} from '@/store/modules/Category/state';
import {CategoryAPI, QueryFromCategory} from '#/Category';

/**
 * Construit la requête pour l'api pour filtrer sur la catégorie donnée
 */
export const queryFromCategory = (category: CategoryAPI | undefined): QueryFromCategory => {
    const query: QueryFromCategory = {};

    if (category) {
        if (category.children) {
            query.parentCategories = category.parentCategory
                ? category.id
                : category.children.map(cat => cat.id);
            return query;
        }

        query.categories = category.id;
    }

    return query;
};

export const getters: GetterTree<CategoryState, RootState> = {
    categories: (state: CategoryState): CategoryAPI[] => state.categories,
    categoryFromId: (state: CategoryState): (id: number) => CategoryAPI | undefined => {
        return id => state.flattenCategories.find(cat => cat.id === id);
    },
    //eslint-disable-next-line
    categoriesFromIdList: (state: CategoryState, getters: any): (idList: number[]) => CategoryAPI[] => {
        return idList => idList.reduce<CategoryAPI[]>((acc, id) => {
                return acc.concat(getters.categoryFromId(id) || []);
            },
            [],
        );
    },
    //eslint-disable-next-line
    queryFromCategoryId: (state: CategoryState, getters: any): (id: number) => QueryFromCategory => {
        return id => queryFromCategory(getters.categoryFromId(id));
    },
};
